export default __webpack_public_path__ + "static/media/engraneGris.a7a9eb55.svg";